<template>
  <div>
    <div class="white--text text-center font-weight-bold">
      Top Growth Strategies for Global Mines
    </div>
    <div class="white--text text-center mb-4">
      Source: (KPMG, 2019)
    </div>
    <div style="border: 1px solid white; border-radius: 15px;" class="pa-3">
      <v-row no-gutters>
        <v-col cols="6">
          <v-row align="center" class="flex-nowrap">
            <v-col cols="auto">
              <v-progress-circular :width="7"
                                   color="white"
                                   :size="70"
                                   :value="73"
                                   :rotate="-90"
              >
          <span style="font-size: 20px;"
                class="white--text"
          >73%
          </span>
              </v-progress-circular>
            </v-col>
            <v-col cols="auto">
              <div class="white--text" style="font-size: 17px;">Organic growth</div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row align="center" class="flex-nowrap">
            <v-col cols="auto">
              <v-progress-circular :width="7"
                                   color="white"
                                   :size="70"
                                   :value="29"
                                   :rotate="-90"
              >
          <span style="font-size: 20px;"
                class="white--text"
          >29%
          </span>
              </v-progress-circular>
            </v-col>
            <v-col cols="auto">
              <div class="white--text" style="font-size: 17px;">Innovation &</div>
              <div class="white--text" style="font-size: 17px;">technological</div>
              <div class="white--text" style="font-size: 17px;">transformation</div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row align="center" class="flex-nowrap">
            <v-col cols="auto">
              <v-progress-circular :width="7"
                                   color="white"
                                   :size="70"
                                   :value="40"
                                   :rotate="-90"
              >
          <span style="font-size: 20px;"
                class="white--text"
          >40%
          </span>
              </v-progress-circular>
            </v-col>
            <v-col cols="auto">
              <div class="white--text" style="font-size: 17px;">Mergers &</div>
              <div class="white--text" style="font-size: 17px;">acquisitions (M&As)</div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row align="center" class="flex-nowrap">
            <v-col cols="auto">
              <v-progress-circular :width="7"
                                   color="white"
                                   :size="70"
                                   :value="27"
                                   :rotate="-90"
              >
          <span style="font-size: 20px;"
                class="white--text"
          >27%
          </span>
              </v-progress-circular>
            </v-col>
            <v-col cols="auto">
              <div class="white--text" style="font-size: 17px;">Joint ventures (JVs)</div>
              <div class="white--text" style="font-size: 17px;">& partnerships</div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopGrowthStrategies"
}
</script>

<style scoped>

</style>